import { render, staticRenderFns } from "./ShipStats.vue?vue&type=template&id=64fc39d8&scoped=true&"
import script from "./ShipStats.vue?vue&type=script&lang=js&"
export * from "./ShipStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fc39d8",
  null
  
)

export default component.exports